import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User imported media to a canvas',
  name: 'canvas_media_imported',
  params: [
    {
      description: 'The id of the canvas',
      name: 'canvas_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The number of media items imported',
      name: 'number_of_media',
      required: true,
      type: 'number',
    },
    {
      description: 'The source from which the media was imported',
      name: 'source',
      required: true,
      type: 'enum',
      values: ['desktop', 'workspace', 'asset_picker'],
    },
    {
      description: 'The id of the board the media was imported from',
      name: 'board_id',
      required: false,
      type: 'string',
    },
  ],
};

export default META;
